import { LoginResponse } from "@/types/auth"
import { MentorsDataType } from "@/types/mentoring"

interface GetMentorPermissionsParams {
  user: LoginResponse | null
  companyMentorId?: number
}

export interface MentorPermissions {
  isAdmin: boolean
  isCompanyPrincipal: boolean
  canManage: boolean
  canUnlink: (mentor: MentorsDataType) => boolean
}

export function getMentorPermissions({
  user,
  companyMentorId,
}: GetMentorPermissionsParams): MentorPermissions {
  const isAdmin = user?.admin === true
  const isCompanyPrincipal =
    companyMentorId !== undefined && user?.mentorId === companyMentorId
  const canManage = isAdmin || isCompanyPrincipal

  const canUnlink = (mentor: MentorsDataType) => {
    if (mentor.tipo === 1) return false
    if (canManage) return true
    return mentor.pes_id === user?.pesId
  }

  return { isAdmin, isCompanyPrincipal, canManage, canUnlink }
}
